import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Immutable from 'immutable'
import config from 'config/api'
import Spinner from 'components/UI/Spinner';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import {Redirect} from 'react-router-dom'
import {withRouter} from 'react-router-dom'
import clsx from 'clsx'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Stu from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {withStyles, useStyles} from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import notifyParentWindowOfSizeChange from 'helpers/notifyParentWindowOfSizeChange'
import PWAPrompt from 'react-ios-pwa-prompt'

const QUIZ = {
  questions: [
    {
      label: 'Poids (kg)',
      type: 'i',
      minLength: 2,
      maxLength: 3,
      max: 200,
      min: 20
    }, {
      label: 'Taille (cm)',
      type: 'i',
      minLength: 2,
      maxLength: 3,
      max: 280,
      min: 20
    }
  ]
};
const Q = Immutable.fromJS(QUIZ);
const styles = (theme) => {
  // console.log(theme.palette)
  return {
    root: {
      maxWidth: 800,
      margin: '0 auto',
      textAlign: 'left',
      '& sup': {
        fontSize: '40%',
        marginLeft: 5
      },
      '& .MuiInputBase-input': {
        textAlign: 'center',
        fontSize: '2rem',
        maxWidth: '5rem',
        [theme.breakpoints.down("sm")]: {
          fontSize: '1.4rem',
          maxWidth: '4rem'
        }
      },
      '& h1': {
        fontSize: '3rem',
        color: theme.palette.secondary.main,
        textAlign: 'center',
        [theme.breakpoints.down("sm")]: {
          fontSize: '1.8rem'
        }

      },
      '& h2': {
        fontSize: '2.4rem',
        color: '#707070',
        [theme.breakpoints.down("sm")]: {
          fontSize: '1.5rem'
        }
      },
      '& h3': {
        fontSize: '2rem',
        color: theme.palette.primary.main,
        [theme.breakpoints.down("sm")]: {
          fontSize: '1.2rem'
        }      },

    },
    header: {
      backgroundColor: theme.palette.primary.main,
      minHeight: 20,
      marginBottom: 20,
    },
    headerTitle: {
      marginBottom: 40,
      [theme.breakpoints.down("sm")]: {
        marginBottom: 20,
      }
    },
    // headerMain: {
    //   borderBottom: '6px '+theme.palette.primary.main+' solid',
    //   marginBottom: 20,
    // },
    // headerLarge: {
    //   backgroundColor: theme.palette.secondary.main,
    //   minHeight: 20,
    //   marginBottom: 0,
    //   padding: '5px 10px',
    // },
    // headerTitle: {
    //   fontSize: '1.5em',
    //   color: '#fff',
    //   padding: '5px 18px'
    // },
    mainContent: {
      padding: '0 20px'
    },
    footer: {
      textAlign: 'center',
      marginTop: 20,
      '& sup': {
        fontSize: '80%'
      }
    },
    // h1: {
    //   fontSize: '2em'
    // },
    // h2: {
    //   fontSize: '1em',
    //   marginBottom: 20
    // },
    caption: {
      color: theme.palette.text.secondary,
      marginBottom: 20,
      display: 'block'
    },
    row: {
      // borderBottom: '2px solid ' + theme.palette.secondary.main,
      // borderLeft: '2px solid ' + theme.palette.secondary.main,
      // borderRight: '2px solid ' + theme.palette.secondary.main,
      // '&:nth-of-type(1)': {
      //   borderTop: '2px solid ' + theme.palette.secondary.main
      // }
    },
    formLabel: {
      padding: '12px 10px',
      fontSize: '2rem',
      // minHeight: '100%',
      // minHeight: 32,
      // paddingTop: 12,
      // lineHeight: 48 + 'px',
      color: theme.palette.secondary.main,
      // height: 48,
      // lineHeight: 48,
      // display: 'flex',
      // flexGrow: 1
      [theme.breakpoints.down("sm")]: {
        fontSize: '1.2rem',
      }

    },
    formChoice: {
      // display: 'flex',
      minHeight: 48,
      lineHeight: 48 + 'px',
      backgroundColor: '#fdefe2',
      // color: theme.palette.secondary.main,
      justifyContent: 'space-around',
      // borderLeft: '2px solid ' + theme.palette.secondary.main
    },
    formRadio: {
      marginRight: 3
    },
    formRadioLabel: {
      color: theme.palette.secondary.main,
      fontWeight: 'bold'
    },
    formRadioIcon: {
      color: theme.palette.secondary.main
    },
    formRadioIconChecked: {
      color: theme.palette.primary.main
    },
    formControl: {
      backgroundColor: 'transparent'
    },
    formSelect: {
      backgroundColor: '#fdefe2',
      height: 48,
      padding: 0
    },
    formSelectIcon: {
      stroke: theme.palette.secondary.main
    },
    formSelectItem: {
      color: theme.palette.secondary.main,
      lineHeight: 48 + 'px',
      paddingLeft: 30,
    },
    formSelectItemSelected: {
      lineHeight: 48 + 'px',
      paddingLeft: 30,
      color: theme.palette.primary.main,
      '&:focus, &:hover, &:active': {
        backgroundColor: '#fdefe2',
        borderBottom: 'none'
      }
    },
    // rightColumnHeader: {
    //   textAlign: 'center',
    //   backgroundColor: theme.palette.primary.main,
    //   color: theme.palette.common.white,
    //   padding: '10px 0',
    //   fontSize: '1.2em',
    //   // borderTop: '2px solid ' + theme.palette.secondary.main,
    //   // borderLeft: '2px solid ' + theme.palette.secondary.main,
    //   // borderRight: '2px solid ' + theme.palette.secondary.main
    // },
    formActions: {
      margin: '20px auto'
    },
    formButton: {
      display: 'block',
      margin: '0 auto'
    },
    logError: {
      color: 'red',
      fontSize: '1.4em'
    },
    green: {
      color: theme.palette.success.main
    },
    orange: {
      color: theme.palette.warning.main
    },
    red: {
      color: theme.palette.error.main
    },
    gutterBottom: {
      marginBottom: 20
    },
    clickable: {
      cursor: 'pointer'
    },
    textInput: {
      textAlign: 'center'
    }
  }
}
function StyledRadio(props) {
  return (<Radio color="primary" {...props}/>);
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props}/>;
}

function toInt(i) {
  return parseInt(i, 10)
}
class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      logError: false,
      logSuccess: false,
      // totalScore: 0,
      // showResults: false,
      // q0: 77,
      // q1: 177
    };
    // const qk = Q.get('questions').size;
    // let i;
    // for (i = 0; i < qk; i++) {
    //   this.state['q' + i] = undefined;
    // }
    this._compute = this._compute.bind(this);
    this._reset = this._reset.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onKeyPress = this._onKeyPress.bind(this);
    this._onInputChange = this._onInputChange.bind(this);
    this._onRadioChange = this._onRadioChange.bind(this);
    this._onSelectChange = this._onSelectChange.bind(this);
    this._nextPage = this._nextPage.bind(this);
    this._previousPage = this._previousPage.bind(this);
  }
  componentDidMount() {
    this._reset(() => {
      notifyParentWindowOfSizeChange();
    });
    // this._compute();
  }

  componentDidUpdate(oldProps) {
    // console.log(oldProps)
    // if (oldProps.classes === undefined && this.props.classes !== undefined) {
    //   console.log('OK')
    // }

  }
  _onInputChange(id, value) {
    // console.log(id, value)
    this.setState({
      ['q' + id]: value
    });
  }
  _onRadioChange(id, value) {
    // console.log(id, value)
    this.setState({
      ['q' + id]: value
    });
  }
  _onSelectChange(id, value) {
    // console.log(id, value)
    this.setState({
      ['q' + id]: value
    });
  }
  _onFocus(id, value) {
    // console.log(id, value)
    this.setState({
      logError: false
    });
  }

  _nextPage() {
    const {page} = this.state;
    const newPage = page < 2 ? page +1 : page;
    this.setState({page: newPage}, () => {
      notifyParentWindowOfSizeChange();
      // setTimeout(() => {window.scrollTo(0,0)}, 100)
      // document.body.scrollTo(0,0)
      window.scrollTo(0,0)
    })
  }
  _previousPage() {
    const {page} = this.state;
    const newPage = page > 0 ? page -1 : page;
    this.setState({page: newPage}, () => {
      notifyParentWindowOfSizeChange();
      // setTimeout(() => {window.scrollTo(0,0)}, 100)
      // document.body.scrollTo(0,0)
      window.scrollTo(0,0)
    })
  }
  _reset(callback) {
    this.setState({
      q0: undefined,
      q1: undefined,
      page: 0
    })
  }

  _onKeyPress(e) {
    if(e.keyCode == 13){
      // console.log('value', e.target.value);
      this._compute();
      // put the login here
    }
  }

  _compute() {
    const {page} = this.state;
    let error, q;
    switch (page) {
      case 1:
      const r = /[^0-9]{1,}/

      const w = this.state.q0 !== undefined ? this.state.q0 : undefined;
      q = Q.get('questions').get(0);
      if (w === undefined || w === '')
      error = q.get('label')+' ne peut être vide !';
      else if (r.test(w))
      error = q.get('label')+' ne peut contenir que des chiffres !';
      else if (w.length > q.get('maxLength'))
      error = q.get('label')+' ne peut que contenir '+q.get('maxLength')+' caractères';
      else if (w.length < q.get('inLength'))
      error = q.get('label')+' doit contenir au moins '+q.get('maxLength')+' caractères';


      const h = this.state.q1 !== undefined ? this.state.q1 : undefined;
      q = Q.get('questions').get(1);
      if (h === undefined || h === '')
      error = q.get('label')+' ne peut être vide !';
      else if (r.test(h))
      error = q.get('label')+' ne peut contenir que des chiffres !';
      else if (h.length > q.get('maxLength'))
      error = q.get('label')+' ne peut que contenir '+q.get('maxLength')+' caractères';
      else if (h.length < q.get('inLength'))
      error = q.get('label')+' doit contenir au moins '+q.get('maxLength')+' caractères';


      if (error) {
        this.setState({logError: error})
        return;
      }
      let score = {}
      score.rsc = 0.0235*Math.pow(h, 0.42246) * Math.pow(w, 0.51456)
      score.rvcn = (23*score.rsc)/1.73
      this.setState({score, page: 2})
      break;
    }
  }
  _getFooter() {
    const {classes} = this.props;
    return (<Typography variant={'caption'} className={classes.caption}><sup>(1)</sup> Convection volume per session needed for an individual patient to have a BSA - adjusted convection volume of at least 23 L or above, based on a measurements of height and weight of the patient. The formula used was: Convection volume
    needed = (23x individual BSA)/1.7. Here BSA (m2) = 0.0235 x height(cm) <sup>0.42246</sup> x weight(kg)<sup>0.5145</sup></Typography>)

  }
  render() {
    const {classes} = this.props;
    const {page, logError, showResults, score, q0, q1} = this.state;
    return (<div className={classes.root}>
      <PWAPrompt
copyTitle={"Ajouter à l'écran d'accueil"}
copyBody={"Ce site à le fonctionnement d'une WebApp. Ajoutez le à votre écran d'accueil pour y accéder hors connextion !"}
copyShareButtonLabel={'1) Appuyez sur le bouton "Partager"'}
copyAddHomeButtonLabel={"2) Appuyez sur ajouter \"Sur l'écran d'accueil\""}
copyClosePrompt={'Annuler'}
promptOnVisit={1} timesToShow={3}
permanentlyHideOnDismiss={false}
        />
      <Choose>
        <When condition={page === 0}>
          <Grid container={true} alignItems="center" justify="space-around" className={classes.mainContent}>
            <Grid item={true} xs={12} className={classes.header}></Grid>
            <Grid item={true} xs={12} className={classes.headerTitle}>
              <Typography variant="h1" className={classes.h1} gutterBottom={true}>
                Calcul du volume convectif rapporté à la
                surface corporelle
                <sup>(1)</sup></Typography>
              </Grid>
              <Grid item={true} xs={12}>
                <Button color="primary" size={'large'} variant="outlined" className={classes.formButton} onClick={this._nextPage}>Continuer &gt;</Button>
              </Grid>
              <Grid item={true} xs={12} className={classes.footer}>
                {this._getFooter()}
              </Grid>
            </Grid>
          </When>
          <When condition={page === 1}>
            <Grid container={true} alignItems="center" justify="space-around" className={classes.mainContent}>
              <Grid item={true} xs={12} className={classes.header}></Grid>
              <Grid item={true} xs={12} className={classes.headerTitle}>
                <Typography variant="h1" className={classes.h1} gutterBottom={true}>
                  Calcul du volume convectif rapporté à la
                  surface corporelle
                  <sup>(1)</sup></Typography>
                </Grid>
                <Grid item={true} xs={12}>
                  <Box boxShadow={2} py={3} px={2} >
                    <Typography variant="h2" className={classes.h2} gutterBottom={true} align="center">
                      Merci de compléter les informations suivantes&nbsp;:
                    </Typography>
                    <Grid container={true} spacing={0} alignItems="center" justify="space-around">
                      {
                        Q.get('questions').map((q, iq) => {
                          return (<Grid key={'q_' + iq} item={true} xs={6} sm={6} className={classes.row}>

                          <If condition={q.get('type') === 'i'}>
                            <FormControl component="fieldset" fullWidth={true} variant="filled" align="center">
                              <Grid container={true} spacing={0} alignItems="center" justify="space-around">
                                <Grid item={true} xs={12} sm={9}>
                                  <FormLabel component="legend" className={classes.formLabel}>{q.get('label')}</FormLabel>
                                  <TextField variant={'outlined'} minLength={q.get('minLength')} maxLength={q.get('maxLength')} onChange={e => this._onInputChange(iq, e.target.value)} className={classes.textInput} onFocus={this._onFocus}  onKeyDown={this._onKeyPress}  align="center"  InputProps={{style: {textAlign: 'center'}}}/>
                                </Grid>
                              </Grid>
                            </FormControl>
                          </If>
                          <If condition={q.get('type') === 'tf'}>
                            <FormControl component="fieldset" fullWidth={true} variant="filled">
                              <Grid container={true} spacing={0} alignItems="center" justify="space-around">
                                <Grid item={true} xs={12} sm={9}>
                                  <FormLabel component="legend" className={classes.formLabel}>{q.get('label')}</FormLabel>
                                </Grid>
                                <Grid item={true} xs={12} sm={3}>

                                  <RadioGroup defaultValue={undefined} aria-label={q.get('label')} name={'radios' + iq} className={classes.formChoice} row={true} onChange={e => this._onRadioChange(iq, e.target.value)}>
                                    <FormControlLabel value="yes" control={<StyledRadio classes = {{root: classes.formRadioIcon, checked: classes.formRadioIconChecked}}/>} label="Oui" classes={{
                                        root: classes.formRadio,
                                        label: classes.formRadioLabel
                                      }}/>
                                      <FormControlLabel value="no" control={<StyledRadio classes = {{root: classes.formRadioIcon, checked: classes.formRadioIconChecked}}/>} label="Non" classes={{
                                          root: classes.formRadio,
                                          label: classes.formRadioLabel
                                        }}/>
                                      </RadioGroup>
                                    </Grid>
                                  </Grid>
                                </FormControl>
                              </If>
                              <If condition={q.get('type') === 's'}>
                                <FormControl component="fieldset" fullWidth={true} variant="filled" className={classes.formControl}>
                                  <Select value={this.state['q' + iq]} onChange={e => this._onSelectChange(iq, e.target.value)} color="secondary" classes={{
                                      root: classes.formSelect,
                                      selectMenu: this.state['q' + iq] !== undefined && this.state['q' + iq] !== ''? classes.formSelectItemSelected : classes.formSelectItem,
                                      icon: classes.formSelectIcon
                                    }} displayEmpty={true}>
                                    <MenuItem value={''}>
                                      <em>...</em>
                                    </MenuItem>
                                    {
                                      q.get('options').map((o, i) => <MenuItem key={'o_' + iq + i} value={i} classes={{
                                        root: classes.formSelectItem
                                      }}>
                                      <em>{o}</em>
                                    </MenuItem>).toArray()
                                  }
                                </Select>
                              </FormControl>
                            </If>

                          </Grid>
                        )}).toArray()}
                      </Grid>
                      <Box pt={3} pb={0} align="center">
                        <Button color="primary" size={'large'} style={{fontSize: '1.4rem'}} variant="outlined" className={classes.formButton} onClick={this._compute} >Calculer</Button>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item={true} xs={12}>
                    <If condition={logError !== false}>
                      <Alert severity="error" style={{marginBottom: 20}}>{logError}</Alert>
                    </If>
                  </Grid>

                  <Grid item={true} xs={12} className={classes.formActions} container={true}>
                    <Button color="secondary" size={'small'} variant="outlined" className={classes.formButton} onClick={this._previousPage}>Retour</Button>
                  </Grid>
                  <Grid item={true} xs={12} className={classes.footer}>
                    {this._getFooter()}
                  </Grid>
                </Grid>
              </When>
              <When condition={page === 2}>
                <Grid container={true} alignItems="center" justify="space-around" className={classes.gutterBottom}>
                  <Grid item={true} xs={12} className={classes.header}></Grid>
                  <Grid item={true} xs={12} className={classes.headerTitle}>
                    <Typography variant="h1" className={classes.h1} gutterBottom={true}>
                      Calcul du volume convectif rapporté à la
                      surface corporelle
                      <sup>(1)</sup></Typography>
                      <Typography variant="h2" className={classes.h2} gutterBottom={true} align="center">
                        Résultat:
                      </Typography>
                    </Grid>
                    <Grid item={true} xs={6} sm={6}>
                      <Box boxShadow={2} py={2} px={2} my={1} mx={2} >
                        <Typography variant="h3" className={classes.h3} gutterBottom={true} align="center">
                          Poids :<br /> <strong>{q0} kg</strong>
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item={true} xs={6} sm={6}>
                    <Box boxShadow={2} py={2} px={2} my={1} mx={2} >
                      <Typography variant="h3" className={classes.h3} gutterBottom={true} align="center">
                        Taille :<br /> <strong>{q1} cm</strong>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item={true} xs={12} sm={6}>
                  <Box boxShadow={2} py={2} px={2} my={1} mx={2} >
                    <Typography variant="h3" className={classes.h3} gutterBottom={true} align="center">
                      Surface Corporelle (cm2) :<br /> <strong>{Math.round(score.rsc*1000)/1000}</strong>
                  </Typography>
                </Box>
              </Grid>
              <Grid item={true} xs={12} sm={6}>
                <Box boxShadow={2} py={2} px={2} my={1} mx={2} >
                  <Typography variant="h3" className={classes.h3} gutterBottom={true} align="center">
                    Volume Convectif Normalisé (L) :<br /> <strong>{Math.round(score.rvcn*1000)/1000}</strong>
                </Typography>
              </Box>
            </Grid>
            <Grid item={true} xs={12} className={classes.formActions} container={true}>
              <Button color="secondary" size={'large'} variant="outlined" className={classes.formButton} onClick={this._reset}>Recommencer</Button>
            </Grid>
            <Grid item={true} xs={12} className={classes.footer}>
              {this._getFooter()}
            </Grid>


          </Grid>
        </When>
      </Choose>

    </div>);
  }
}
function mapStateToProps(state) {
  const props = {};
  return props;
}
function mapDispatchToProps(dispatch) {
  return {};
}

export default withRouter(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Home)));



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx